import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
/**
 * Constants
 */
var LOGO = 'https://www.leaseplan.com/static/images/logo-navigation.png';
var LOGO_2X = 'https://www.leaseplan.com/static/images/logo-navigation@2x.png';
var WIDTH = 228;
var HEIGHT = 104;
var COLLAPSE = 44;
/**
 * Styles
 */
var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    image: {
        marginTop: '36px',
    },
    expanded: function (_a) {
        var width = _a.width;
        return ({
            width: width + "px",
            overflow: 'visible',
        });
    },
    expandedImage: {
        marginLeft: 0,
    },
    collapsed: function (_a) {
        var width = _a.width;
        return ({
            width: width - COLLAPSE + "px",
            overflow: 'hidden',
        });
    },
    collapsedImage: {
        marginLeft: -COLLAPSE + "px",
    },
}); });
/**
 * Logo component
 */
export var Logo = function (_a) {
    var className = _a.className, imageClassName = _a.imageClassName, _b = _a.type, type = _b === void 0 ? 'expanded' : _b, logo = _a.logo;
    var _c = logo || {}, _d = _c.width, width = _d === void 0 ? WIDTH : _d, _e = _c.height, height = _e === void 0 ? HEIGHT : _e, _f = _c.url, url = _f === void 0 ? LOGO : _f, _g = _c.url2x, url2x = _g === void 0 ? LOGO_2X : _g;
    var classes = useStyles({ width: width });
    return (React.createElement("div", { className: clsx(classes.root, type === 'expanded' ? classes.expanded : classes.collapsed, className) },
        React.createElement("img", { src: url, srcSet: url2x + " 2x", width: width, height: height, alt: "LeasePlan Logo", className: clsx(classes.image, type === 'expanded' ? classes.expandedImage : classes.collapsedImage, imageClassName) })));
};
//# sourceMappingURL=Logo.js.map